export const SAMPLE_LIST_REQUEST = "SAMPLE_LIST_REQUEST";
export const SAMPLE_LIST_SUCCESS = "SAMPLE_LIST_SUCCESS";
export const SAMPLE_LIST_FAIL = "SAMPLE_LIST_FAIL";
